import CustomModal from '../../../components/CustomModal';
import ViewReverse from '../../../components/ViewReverse';
import { ReactSVG } from 'react-svg';
import { Button, ErrorText, Text } from '../../../components/SecondaryMarket';
import { fontSizes } from '../../../constants/constants';
import ViewItems from '../../../components/ViewItems';
import icons from '../../../constants/icons';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../../store/actions/authActions';

const RejectionModal = ({ TextWeight, setRejectionModal, rejectionModal, rejection_summary, getContentKey,logout, isAccountOpening, isArabic }) => {
    const dispatch = useDispatch();

    const handleLogout = () => {
        if (isAccountOpening) {
            logout();
        } else {
            setRejectionModal(false);
            dispatch(logoutUser(null, isArabic));
        }
    };

    return (
        <div className="flex items-center">
            <CustomModal isOpen={rejectionModal} isFullWidth={true} maxWidth={'sm'} heading={getContentKey('welcome_to_your_dashboard')} isHeader={false} isCenter>
                <ViewReverse className={'justify-between'}>
                    <div />
                </ViewReverse>
                <ReactSVG src={icons.application_info_red} className='mx-auto w-fit' />
                <Text text={getContentKey('the_application_could_not_be_verified')} weight={TextWeight.headingRegular} className={'text-dark-blue mt-5 text-lg'} size={fontSizes.h22} align={'text-center'} />
                <Text
                    text={getContentKey('application_verification_text')} className={'mt-2 text-xs'} align={'text-center'} />

                <ViewItems className={'mt-5 gap-2 border border-border rounded-md p-3'}>
                    {
                        rejection_summary?.map((item, index) => {
                            const rejectedFields = item?.rejectedFields || [];

                            return (
                                rejectedFields?.map((field, index) => (
                                    <ViewReverse className={'gap-2 items-center'} key={index}>
                                        <ReactSVG src={icons.field_info_outline} />
                                        <ViewItems>
                                            <ErrorText text={field?.fieldName} className={'mt-0 '} />
                                        </ViewItems>
                                    </ViewReverse>

                                ))
                            )
                        })
                    }
                </ViewItems>
                <ViewReverse className={"flex gap-2 justify-between mt-4"}>
                    <Button text={getContentKey('logout')} textSize={"small"} className={"rounded text-xs flex-1 bg-white border border-border text-black"}
                        onClick={handleLogout} />
                    <Button text={getContentKey('review_form')} className="text-xs flex-1 rounded " onClick={() => setRejectionModal(false)} />
                </ViewReverse>
            </CustomModal>
        </div>
    )
}

export default RejectionModal;